import axios from 'axios';

export async function selectFile() {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '".doc,.docx,.xlsx,.ods, .odt, .pdf,.csv"';
    input.onchange = () => {
      if (input.files.length > 0) {
        resolve(input.files[0]);
      } else {
        reject(new Error('Nenhum arquivo selecionado.'));
      }
    };
    input.click();
  });
}

export async function listFiles(apiHost, empresa, departamento, ano, mes) {
  try {
    const response = await axios.get(`${apiHost}/onedrive/files`, {
      params: { empresa, departamento, ano, mes }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao listar arquivos:", error);
    throw error;
  }
}

export async function downloadAllFiles(apiHost, empresa, departamento, ano, mes, authToken) {
  try {
    const departamentoFinal = departamento || "GERAL";
    const files = await listFiles(apiHost, empresa, departamentoFinal, ano, mes, authToken);
    
    if (!files || files.length === 0) {
      throw new Error("Nenhum arquivo encontrado na pasta");
    }

    const downloadResults = {
      success: 0,
      failed: 0,
      errors: []
    };

    for (const [index, file] of files.entries()) {
      try {
        
        const response = await axios.get(
          `${apiHost}/onedrive/download/${file.id}/${empresa}/${departamentoFinal}/${ano}/${mes}`,
          {
            responseType: 'blob',
            headers: { 
              Authorization: authToken,
            },
            timeout: 30000
          }
        );

        const blob = new Blob([response.data]);
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = file.name || `arquivo_${empresa}_${departamentoFinal}_${ano}-${mes}_${index + 1}`;
        a.style.display = 'none';
        
        a.onclick = () => {
          setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);
          }, 100);
        };

        document.body.appendChild(a);
        a.click();
        
        downloadResults.success++;
        
        if (index < files.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 300));
        }

      } catch (error) {
        downloadResults.failed++;
        downloadResults.errors.push({
          file: file.name || file.id,
          error: error.message
        });
        
        continue;
      }
    }

    if (downloadResults.failed > 0) {
      if (downloadResults.success === 0) {
        throw new Error("Todos os downloads falharam: " + 
          downloadResults.errors.map(e => e.file).join(", "));
      }
      
      return {
        count: downloadResults.success,
        warnings: downloadResults.errors
      };
    }

    return downloadResults.success;

  } catch (error) {
    throw new Error(error.message || "Falha ao baixar arquivos");
  }
}

export async function uploadFile(apiHost, file, empresa, departamento, ano, mes, authToken) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("filename", file.name);
    formData.append("empresa", empresa);
    formData.append("departamento", departamento || "GERAL");
    formData.append("ano", ano);
    formData.append("mes", mes);

    const response = await axios.post(`${apiHost}/onedrive/upload`, formData, {
      headers: {
        'Authorization': authToken,
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}